import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

export const AuthCallback = () => {
  const [status, setStatus] = useState<string>("Processing OAuth callback...");
  const [details, setDetails] = useState<string>("");

  useEffect(() => {
    const run = async () => {
      try {
        const url = new URL(window.location.href);
        const code = url.searchParams.get("code");
        const hash = window.location.hash;

        if (code) {
          setStatus("Exchanging code for session...");
          const { error } = await supabase.auth.exchangeCodeForSession(code);
          if (error) {
            setStatus("Failed to exchange code.");
            setDetails(error.message ?? String(error));
            return;
          }
          setStatus("Session established. Redirecting...");
          window.history.replaceState({}, document.title, "/");
          window.location.href = "/";
          return;
        }

        if (hash && hash.includes("access_token")) {
          setStatus("Setting session from hash tokens...");
          const p = new URLSearchParams(hash.substring(1));
          const access_token = p.get("access_token") || undefined;
          const refresh_token = p.get("refresh_token") || undefined;
          if (access_token && refresh_token) {
            const { error } = await supabase.auth.setSession({ access_token, refresh_token });
            if (error) {
              setStatus("Failed to set session from hash.");
              setDetails(error.message ?? String(error));
              return;
            }
            setStatus("Session established. Redirecting...");
            window.history.replaceState({}, document.title, "/");
            window.location.href = "/";
            return;
          }
        }

        setStatus("No OAuth code or tokens found in URL.");
        setDetails("Ensure Supabase redirect points to /auth/callback and try again.");
      } catch (e: any) {
        setStatus("Unexpected error processing callback.");
        setDetails(e?.message ?? String(e));
      }
    };
    run();
  }, []);

  return (
    <main className="min-h-screen bg-gradient-bg flex items-center justify-center p-6">
      <section className="max-w-md w-full bg-card text-card-foreground rounded-xl shadow-lg p-6 space-y-3">
        <h1 className="text-xl font-semibold">Signing you in…</h1>
        <p className="text-sm opacity-80">{status}</p>
        {details && (
          <pre className="text-xs bg-muted text-muted-foreground p-3 rounded-md overflow-auto">
            {details}
          </pre>
        )}
        <a href="/auth" className="underline text-primary text-sm">Back to login</a>
      </section>
    </main>
  );
};

export default AuthCallback;
